import { Record } from "immutable";

import ClassLeaderboardsHistory from "./classLeaderboardsHistory";
import MetaSlice from "./meta";

export type ClassLeaderboardsStateSliceType = {
  history: ClassLeaderboardsHistory;
  meta: MetaSlice;
};

const defaultClassLeaderboardsStateSlice: ClassLeaderboardsStateSliceType = {
  history: new ClassLeaderboardsHistory(),
  meta: new MetaSlice()
};

export default class ClassLeaderboardsStateSlice extends Record(
  defaultClassLeaderboardsStateSlice
) {}
